import dayjs from 'dayjs'

export const formatEventDate = (date?: Date | string): string => {
  if (!date) return ''
  const eventDate = dayjs(date)
  const today = dayjs().startOf('day')
  
  if (eventDate.isSame(today, 'day')) {
    return 'Today'
  }
  return eventDate.format('MM/DD/YYYY')
}

export const formatEventTime = (date?: Date | string): string => {
  if (!date) return ''
  return dayjs(date).format('h:mm A')
}

export const formatEventTime24 = (date?: Date | string): string => {
  if (!date) return ''
  return dayjs(date).format('HH:mm')
}

export const formatEventDateFull = (date?: Date | string): string => {
  if (!date) return ''
  return dayjs(date).format('MMMM D, YYYY')
}

export const formatEventDuration = (minutes?: number): string => {
  if (!minutes) return ''
  const hours = Math.floor(minutes / 60)
  const mins = minutes % 60
  if (hours > 0 && mins > 0) {
    return `${hours} hour${hours > 1 ? 's' : ''} ${mins} minute${mins > 1 ? 's' : ''}`
  } else if (hours > 0) {
    return `${hours} hour${hours > 1 ? 's' : ''}`
  }
  return `${mins} minute${mins > 1 ? 's' : ''}`
}

export const formatEventDurationShort = (minutes?: number): string => {
  if (!minutes) return ''
  const hours = Math.floor(minutes / 60)
  const mins = minutes % 60
  if (hours > 0) {
    return mins > 0 ? `${hours}h ${mins}min` : `${hours}h`
  }
  return `${mins}min`
}

